import { useState } from 'react'
import type { ContentProps } from '../../option-menu/components/item'

export function useSelect() {
  const [selectedOption, setSelectedOption] = useState<ContentProps>()
  return {
    useSelect,
    selectedOption,
    setSelectedOption,
  }
}
